import { GeneralErrorBoundary } from '@/components/errorBoundaries/generalErrorBoundary';
import { MifeParcel } from '@/components/MifeParcel';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/_pfida/grow-your-savings')({
  component: () => <MifeParcel />,
  errorComponent: GeneralErrorBoundary,
});
